module.exports = __webpack_public_path__ + "img/page_img5.ad59d846.jpg";